import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { TableColumn } from '@swimlane/ngx-datatable';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { assignTags, deleteApp } from '../../app.actions';
import { App, AppState, Contract, TagChanges } from '../../app.models';
import { selectContract } from '../../app.selector';
import { TagColWithNumberPipe } from '../pipes/TagColPipe';

@Component({
  selector: 'app-app-overview',
  templateUrl: './app-overview.component.html',
  styleUrls: ['./app-overview.component.scss'],
})
export class AppOverviewComponent implements AfterViewInit, OnDestroy {
  @ViewChild('buttonsTemplate') buttonsTemplate: TemplateRef<any>;
  @ViewChild('typeTemplate') typeTemplate: TemplateRef<any>;
  @ViewChild('deleteDialog') deleteDialog: TemplateRef<any>;
  @ViewChild('tagAssignDialog') tagAssignDialog: TemplateRef<any>;
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
  @ViewChild('nameHdrTpl') nameHdrTpl: TemplateRef<any>;
  @ViewChild('tagsTemplate') tagsTemplate: TemplateRef<any>;
  @ViewChild('tagGroupsTemplate') tagGroupsTemplate: TemplateRef<any>;

  columns: TableColumn[];
  $data: Observable<App[]>;
  selectedContract$: Subscription;
  env = environment;
  contract: Contract = {} as Contract;
  $count: Observable<number>;

  constructor(
    private store: Store,
    private cd: ChangeDetectorRef,
    private dialogService: NbDialogService,
    private title: Title
  ) { }

  open(dialogAppCreation: TemplateRef<any>) {
    this.dialogService.open(dialogAppCreation, { context: 'this is some additional data passed to dialog' });
  }

  ngAfterViewInit() {
    this.searchInput.nativeElement.focus();
    this.columns = [
      {
        name: 'Actions',
        prop: '',
        headerTemplate: this.nameHdrTpl,
        cellTemplate: this.buttonsTemplate,
        minWidth: 140,
        maxWidth: 140,
        sortable: false
      },
      {
        name: 'Platform',
        prop: 'platform',
        headerTemplate: this.nameHdrTpl,
        cellTemplate: this.typeTemplate,
        minWidth: 90,
        maxWidth: 90,
        sortable: false
      },
      { name: 'Name', prop: 'name', headerTemplate: this.nameHdrTpl, maxWidth: 300 },
      { name: 'Tags', prop: 'tags', headerTemplate: this.nameHdrTpl, cellTemplate: this.tagsTemplate, pipe: new TagColWithNumberPipe() },
      { name: 'Groups', prop: 'groups', headerTemplate: this.nameHdrTpl, cellTemplate: this.tagGroupsTemplate, pipe: new TagColWithNumberPipe() },
    ];

    this.selectedContract$ = this.store.select(selectContract)
      .pipe(
        filter(c => !!c),
      )
      .subscribe((c) => {
        this.contract = c;
        this.title.setTitle(`Apps - ${c.name}`);
      });

    this.$data = this.store.select((state: AppState) => state.apps);
    this.$count = this.store.select((state: AppState) => state.apps.length);

    this.cd.detectChanges();
  }

  updateFilter(event) {
    const input = event.target.value.toLowerCase();
    this.$data = this.store.select((state: AppState) => state.apps)
      .pipe(
        map(apps => apps.filter(app => app.name.toLowerCase().includes(input)))
      );
  }

  handleClickDelete(app: App) {
    this.cd.detectChanges();
    const context = {
      app,
      delete: () => this.store.dispatch(deleteApp({ payload: app }))
    }
    // https://github.com/swimlane/ngx-datatable/issues/721#issuecomment-325550591
    setTimeout(() => {
      this.dialogService.open(this.deleteDialog, { context });
    })
  }

  handleClickTagAssign(app: App) {
    this.cd.detectChanges();
    const context = {
      selectedTags: [...app.tags, ...app.groups].map(e => e.id),
      changes: [],
      assign: (changes: TagChanges[]) => this.store.dispatch(assignTags({ payload: { app, changes } }))
    }
    // https://github.com/swimlane/ngx-datatable/issues/721#issuecomment-325550591
    setTimeout(() => {
      this.dialogService.open(this.tagAssignDialog, { context });
    })
  }

  ngOnDestroy() {
    this.selectedContract$.unsubscribe();
  }

}
